

import React, { useState, useEffect } from "react";
import '../styles/packages.scss';
import { TiTick } from "react-icons/ti";
import project_1 from "../images/project_1.png"
import project_3 from "./../images/project_3.png"
import project_4 from "./../images/project_4.png"
import project_5 from "./../images/project_5.png"
import project_6 from "./../images/project_6.png"
import project_7 from './../images/project_7.png'
import { FaTypo3 } from "react-icons/fa";
export default function Packages() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Initial check

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const packages = [
    {
      heading: "Class Crafter - Collaborative Learning Platform",
      image:project_7,
      link:"https://github.com/yashal-ali/ClasssCrafterConnet-3Cs-",
      points: [
        "A collaborative classroom platform was developed, allowing users to create and manage virtual classrooms, secure user authentication, real-time collaboration, and seamless chat integration using Socket.io and Live Kit",
      ],
      benifits: [
        "NextJs",
        "Node Js",
        "TailwindCss",
        "Socket.io",
        "LiveKit",
      ],
    },
    {
      heading: "LinguaGlimmer: Illuminating Insights from Research Papers",
      image:project_1,
      link:"https://github.com/yashal-ali/LinguaGlimmer-LandingPage",
      points: [
        "LinguaGlimmer is an innovative chat application that empowers students to upload PDFs containing research papers, articles, or question-answer formats. The application then utilizes advanced language processing techniques to generate relevant questions based on the uploaded content. Users can interact with the AI-powered chat interface to ask questions and receive insightful responses tailored to the material they've uploaded",
      ],
      benifits: [
        "React JS",
        "TailWindCSS",
        "Next Js",
        "CSS"

      ],
    },
    {
      heading: "Trade Analysis Dashboard",
      image:project_3,
      link:"https://app.sonar-sight.com/",
      points: [
        "Enable users to interactively explore trade data through various visualization methods.Implemented charting libraries to visualize trade data Created a responsive and user-friendly interface for uploading and analyzing trade data Customized chart options",
      ],
      benifits: [
        "React Js",
        "TailwindCSS",
        "Chart Js",
        "PDF Js",
        "React Forms",
        "Integration Rest API",

      ],
    },
  ];
  const packages_1 = [
    {
      heading: "Meral EStore",
      image:project_4,
      link:"https://github.com/yashal-ali/LinguaGlimmer-LandingPage",
      points: [
        "Meral eStore is a user-friendly eCommerce platform with an intuitive design, secure payment gateway, and robust backend REST API, providing a seamless shopping experience across all devices and seamless integration with third-party services.",
      ],
      benifits: [
        "Next Js",
        "Material UI",
        "Fromik",
        "Rest Api Integration",
        "React Js",
      ],
    },
    {
      heading: "DESIGNER GENE’S",
      image:project_6,
      link:"https://app.thedesignergenesco.com/",
      points: [
        "Designed and implemented a health report analysis and shipment dashboard Integrated Stripe API to allow users to ship their reports. Implemented a coach feature to provide guidance and support to users. Created a responsive and user-friendly interface for uploading and analyzing lab reports",
      ],
      benifits: [
        "React Js",
        "Strip",
        "TailWindcss",
        "CSS",
        "Typescript"
      ],
    },
    {
      heading: "Artilizer - Summarization Web Application",
      image:project_5,
      link:"https://64457599092a256b9e28c759--keen-paprenjak-70a0f0.netlify.app/",
      points: [
        "Integrated a text summarization API to generate concise summaries of news articles. Created a user-friendly interface for users to input news article URLs.Displayed the summarized content to the users.",
      ],
      benifits: [
        "Next Js",
        "Api Integration",
        "TailWindcss",
        "CSS",
        "Typescript"
      ],
    },
  ];
  return (
    <section id="packages" className="overflow-hidden py-5">
    <div className="container">
      <div className="d-flex flex-column gap-2 mb-lg-3 mb-md-2 mb-5">
        <h1 className="h2 fw-bold text-center text-uppercase text-gradient m-0 mb-4">
          PORJECTS
        </h1>
      </div>
      <div className="row justify-content-center">
        <div className="packages-ctn">
          {packages.map((pkg, index) => {
            let aosEffect = "";
            if (index === 0) aosEffect = "fade-left";
            if (index === 1) aosEffect = "fade-center";
            if (index === 2) aosEffect = "fade-right";

            return (
              <div
              key={index}
              className={`card package-card shadow-0 overflow-hidden h-100 ${
                !isMobile && index === 1 ? "active" : ""
              }`}
              data-aos={aosEffect}
            > <a href={pkg.link}>
              <div className="card-header p-2 border-0">
                <img src={pkg.image} className="card-header-image " alt="project"/>
               
                <h3
                  className="card-title text-center fw-bold m-0 text-dark"
                  dangerouslySetInnerHTML={{ __html: pkg.heading }}

                />
       
               
              </div>
              <div className="card-body p-2">
                <ul className="card-body-benefit">
                  {pkg.points.map((point, idx) => (
                    <div className="card-body-line" key={idx}>
                      <TiTick /><li className="m-0">{point}</li>
                    </div>
                  ))}
                </ul>
              </div>
            
              <div className="card-body p-2">
                <ul className="d-flex flex-column gap-1 m-0 benefits">
                  {pkg.benifits.map((benifit, idx) => (
                    <small className="service px-3 py-2 rounded-pill d-flex align-items-center gap-2" key={idx}>
                    <FaTypo3 className="service_icon" />
                    <span>{benifit}</span>
                </small>
                  ))}
                </ul>
              </div>

              </a>
            </div>
            );
          })}
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="packages-ctn">
          {packages_1.map((pkg, index) => {
            let aosEffect = "";
            if (index === 0) aosEffect = "fade-left";
            if (index === 1) aosEffect = "fade-center";
            if (index === 2) aosEffect = "fade-right";

            return (
              <div
                key={index}
                className={`card package-card shadow-0 overflow-hidden h-100 ${
                  !isMobile && index === 1 ? "active" : ""
                }`}
                data-aos={aosEffect}
              > <a href={pkg.link}>
                <div className="card-header p-2 border-0">
                  <img src={pkg.image} className="card-header-image " alt="project"/>
                 
                  <h3
                    className="card-title text-center fw-bold m-0 text-dark"
                    dangerouslySetInnerHTML={{ __html: pkg.heading }}

                  />
         
                 
                </div>
                <div className="card-body p-2">
                  <ul className="d-flex flex-column gap-1 m-0">
                    {pkg.points.map((point, idx) => (
                      <div className="card-body-line" key={idx}>
                        <TiTick /><li className="m-0">{point}</li>
                      </div>
                    ))}
                  </ul>
                </div>
              
                <div className="card-body p-2">
                <ul className="d-flex flex-column gap-1 m-0 benefits">
                  {pkg.benifits.map((benifit, idx) => (
                    <small className="service px-3 py-2 rounded-pill d-flex align-items-center gap-2" key={idx}>
                    <FaTypo3 className="service_icon" />
                    <span>{benifit}</span>
                </small>
                  ))}
                </ul>
                </div>

                </a>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  </section>
  );

}
